export default "__VITE_ASSET__841fa0f7__"